/**
  *
  * DEPENDENCIES: Scroll.js
  *
  */

  ((InstagramModal, $) => {
    'use strict';

    const allImages = [];

    let $instagramFeed;
    let $body;

    const cacheDom = () => {
      $instagramFeed = $('.instagram-feed');
      $body = $('body');
    };

    const buildModal = (sourceImage, index) => {
      let html = '';
      html += '<div id="instagram-modal">';
      html += '<div class="instagram-modal-hide"></div>';
      html += '<div class="instagram-modal-image-container">';
      html += '<img class="instagram-modal-image"';
      html += 'data-current-index="';
      html += index;
      html += '" src="';
      html += sourceImage;
      html += '" />'; // Ends/Closes img tag
      html += '<div class="instagram-modal-x"><p class="fa fa-times"></p></div>';
      html += '<div class="instagram-modal-prev" data-index="';
      html += index; // Index left in but not necessary
      html += '"><p class="fa fa-chevron-circle-left"></p></div>';
      html += '<div class="instagram-modal-next" data-index="';
      html += index; // Index left in but not necessary
      html += '"><p class="fa fa-chevron-circle-right"></p></div>';
      html += '</div>';
      html += '</div>';
      return html;
    };

    const setImageIndexes = (currentIndex, changeType) => {
      let newPrevIndex;
      let newNextIndex;
      let newImgIndex;

      if (currentIndex === 0 && changeType === 'prev') {
        newPrevIndex = allImages.length - 2;
        newNextIndex = currentIndex;
        newImgIndex = allImages.length - 1;
      } else if (currentIndex === allImages.length - 1 && changeType === 'next') {
        newPrevIndex = currentIndex;
        newNextIndex = 1;
        newImgIndex = 0;
      } else if (currentIndex === 1 && changeType === 'prev') {
        newPrevIndex = allImages.length - 1;
        newNextIndex = currentIndex;
        newImgIndex = 0;
      } else if (currentIndex === allImages.length - 2 && changeType === 'next') {
        newPrevIndex = currentIndex;
        newNextIndex = 0;
        newImgIndex = currentIndex + 1;
      } else if (changeType === 'prev') {
        newPrevIndex = currentIndex - 2;
        newNextIndex = currentIndex;
        newImgIndex = currentIndex - 1;
      } else if (changeType === 'next') {
        newPrevIndex = currentIndex;
        newNextIndex = currentIndex + 2;
        newImgIndex = currentIndex + 1;
      }

      return [newPrevIndex, newNextIndex, newImgIndex];
    };

    const changeImage = ($imgTag, indexes) => {
      $imgTag.parent().hide()
        .find('.instagram-modal-prev')
        .attr('data-index', indexes[0])
        .parent()
        .find('.instagram-modal-next')
        .attr('data-index', indexes[1])
        .parent()
        .find('img')
        .attr('src', allImages[indexes[2]])
        .attr('data-current-index', indexes[2])
        .parent()
        .fadeIn(300);
    };

    const itemIndexInArray = (arr, item) => {
      return arr.indexOf(item);
    };

    const show = () => {
      $('#instagram-modal').fadeIn(300).css('display', 'flex');
      window.Scroll.lock();
    };

    const switchModal = ($node, direction) => {
      const $imgTag = $node.parent().find('img');
      const currentIndex = parseInt($node.parent().find('img').attr('data-current-index'), 10);
      const indexes = setImageIndexes(currentIndex, direction);

      changeImage($imgTag, indexes);
    };

    const bindUIActions = () => {
      $(document).on('keydown', (event) => {
        if ($('#instagram-modal').is(':visible')) {
          if (event.keyCode.toString() === '37') {
            const node = $('.instagram-modal-prev');
            switchModal(node, 'prev');
          }

          if (event.keyCode.toString() === '39') {
            const node = $('.instagram-modal-next');
            switchModal(node, 'next');
          }
        }
      });

      $instagramFeed.delegate('img', 'click', function createModal() {
        const currentImage = $(this).attr('src');

        if (allImages.length === 0) {
          $($(this).parent().children('img')).each(function pushToArray() {
            allImages.push($(this).attr('src'));
          });
        }

        const index = itemIndexInArray(allImages, currentImage);
        const html = buildModal(currentImage, index);

        $body.prepend(html);

        show();
      });

      $body.delegate('.instagram-modal-hide', 'click', function hideModal() {
        $(this).parent().fadeOut(300).remove();
        window.Scroll.unlock();
      });

      $body.delegate('.instagram-modal-x', 'click', function hideModalFromX() {
        $(this).parent().parent()
          .fadeOut(300)
          .remove();
        window.Scroll.unlock();
      });

      $body.delegate('.instagram-modal-prev', 'click', function previousItem() {
        switchModal($(this), 'prev');
      });

      $body.delegate('.instagram-modal-next', 'click', function nextItem() {
        switchModal($(this), 'next');
      });

      $instagramFeed.delegate('.instagram-feed-promo', 'click', () => {
        const currentImage = $($instagramFeed.find('#instafeed').children()[0]).attr('src');

        if (allImages.length === 0) {
          $($instagramFeed.find('#instafeed').children('img')).each(function pushToArray() {
            allImages.push($(this).attr('src'));
          });
        }

        const index = itemIndexInArray(allImages, currentImage);
        const html = buildModal(currentImage, index);

        $body.prepend(html);

        show();
      });
    };

    const init = () => {
      cacheDom();
      bindUIActions();
    };

    InstagramModal.init = init;
  })(window.InstagramModal = window.InstagramModal || {}, jQuery);
